import { render } from "./ReportElementSettingsPanel.vue?vue&type=template&id=67495bdc&ts=true"
import script from "./ReportElementSettingsPanel.vue?vue&type=script&lang=ts"
export * from "./ReportElementSettingsPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__